import { Hammer } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Maintenance() {
    const { t } = (useTranslation as any)('common');

    return (
        <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-4 text-center">
            <div className="w-24 h-24 bg-blue-600/20 rounded-full flex items-center justify-center mb-6 animate-pulse">
                <Hammer className="w-12 h-12 text-blue-500" />
            </div>

            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
                {t('maintenance.title')}
            </h1>

            <p className="text-slate-400 text-lg max-w-md mx-auto mb-8">
                {t('maintenance.subtitle')}
            </p>

            <div className="text-sm text-slate-600">
                {t('maintenance.team')}
            </div>

            <button
                onClick={() => window.location.reload()}
                className="mt-8 px-6 py-2 bg-slate-800 text-white rounded-lg hover:bg-slate-700 transition"
            >
                {t('maintenance.refresh')}
            </button>
        </div>
    );
}
